// extracted by mini-css-extract-plugin
export default {"sectionTitle":"Projects_sectionTitle__rvBgF","featuredProjectCards":"Projects_featuredProjectCards__yRcQ2","seeMore":"Projects_seeMore__bkAXI"};